export const pluginSettingOwner = 'postmaster@portal.blip.ai';
const SERVER_APPLICATION_URL = 'postmaster@plugins';
// TODO: Change storage location
// Using configuration as storage is not a good practice
export class ExternalPluginService {
    static $inject = ['ConfigurationsService', 'AuthenticationService', 'BlipService', 'BLIP_DOMAIN'];
    constructor(ConfigurationsService, AuthenticationService, BlipService, BLIP_DOMAIN) {
        this.ConfigurationsService = ConfigurationsService;
        this.AuthenticationService = AuthenticationService;
        this.BlipService = BlipService;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
    }
    async connectBlipClient() {
        if (!(await this.BlipService.isConnected())) {
            await this.BlipService.connect(encodeURIComponent(this.AuthenticationService.email), this.AuthenticationService.token);
        }
    }
    async getPlugins(useConfigurationsApplication = false) {
        const settings = await this.ConfigurationsService.get(pluginSettingOwner, undefined, useConfigurationsApplication);
        return JSON.parse(settings.Plugins) || {};
    }
    async getPlugin(pluginId, useConfigurationsApplication = false) {
        const plugins = await this.getPlugins(useConfigurationsApplication);
        return plugins[pluginId];
    }
    async getPluginPermissions(applicationId, pluginId, culture) {
        await this.connectBlipClient();
        const language = culture.split('-')[0];
        const commandResponse = await this.BlipService.processCommand({
            to: `${SERVER_APPLICATION_URL}.${this.BLIP_DOMAIN}`,
            method: 'get',
            uri: `lime://${applicationId}/profile-permission/plugins/${pluginId}/permission-needed?language=${language}`,
        });
        this.BlipService.ensureCommandSuccess(commandResponse);
        return commandResponse.resource.items;
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
ExternalPluginService.$inject = ['ConfigurationsService', 'AuthenticationService', 'BlipService', 'BLIP_DOMAIN'];
